// src/hooks/useLogout.ts

export const useLogout = () => {
  return () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth');
    localStorage.removeItem('token');
    localStorage.removeItem('currentSelections');
    window.location.href = '/login';
  };
};
